module.exports = __webpack_public_path__ + "media/images/store/app_store-1ece58c658328414e372988427792236.png";